import { useEffect, useState } from "react";
import { useGA4 } from "@/app/hooks/useGA4";
import { useGoogleTagManager } from "@/app/utils/googleAnalytics/useGoogleTagManager";
import dataService from "@/app/services/dataService";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store/store";
import { getAnonymousUserToken } from "@/app/utils/algoliaUserToken";
import { isKioskMode } from "@/app/utils/kioskManager";

export const AppGAInitializer = () => {
  const [settings, setSettings] = useState<any>(null);

  var originalUserType = useSelector(
    (state: RootState) => state.userState.user.originalUserType
  );
  var isZendeskCustomer = useSelector(
    (state: RootState) => state.userState.user.isZendeskCustomer
  );
  var originalUserId = useSelector(
    (state: RootState) => state.userState.user.originalUserId
  );

  // Google Tag Manager Initialization
  useEffect(() => {
    if (process.env.REACT_APP_GTM_KEY) {
      const isKiosk = isKioskMode();

      // GTM Variables (JavaScript variables)
      (window as any).userId = originalUserId;
      (window as any).Var_userid = originalUserId;
      (window as any).Var_user_type = originalUserType;
      (window as any).Var_is_zendesk_customer = isZendeskCustomer;

      (window as any).dataLayer = (window as any).dataLayer || [];
      if (isKiosk) {
        (window as any).dataLayer.push({
          Var_userid: originalUserId,
        });
      } else {
        const visitorId = getAnonymousUserToken();
        (window as any).Var_visitor_id = visitorId;
        (window as any).dataLayer.push({
          Var_userid: originalUserId,
          Var_visitor_id: visitorId,
        });
      }
    }
  }, [originalUserId, originalUserType, isZendeskCustomer]);

  useEffect(() => {
    const fetchSettings = async () => {
      const res = await dataService.getGASettings();
      setSettings(res.data);
    };
    fetchSettings();
  }, []);

  useGoogleTagManager(process.env.REACT_APP_GTM_KEY ?? "");
  useGA4(settings?.googleId);

  useEffect(() => {
    if (originalUserId && window.gtag) {
      window.gtag("set", { user_id: originalUserId });
    }
  }, [originalUserId, settings]);

  return null;
};
